/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

//<custom-head>
import { ArticleAttachedDocumentDto } from './article-attached-document-dto';
//</custom-head>

export class ClearanceCaseRowAttachedDocumentDto {
  public id: number = undefined;
  public attachedDocumentTypeId: number = undefined;
  public attachedDocumentSubtypeId: number = undefined;
  public countryCode: string = undefined;
  public data: string = undefined;

  //<custom-body>
  public static fromArticle(articleAttachedDocument: ArticleAttachedDocumentDto): ClearanceCaseRowAttachedDocumentDto {
    const doc = new ClearanceCaseRowAttachedDocumentDto();

    doc.attachedDocumentSubtypeId = articleAttachedDocument.attachedDocumentSubtypeId;
    doc.attachedDocumentTypeId = articleAttachedDocument.attachedDocumentTypeId;
    doc.countryCode = articleAttachedDocument.countryCode;
    doc.data = articleAttachedDocument.data;

    //TODO: Add in documenttypeid

    return doc;
  }
  //</custom-body>
}
